import React, {useEffect} from 'react'
import FeeStructureImg from '../Assets/FeeStructure.jpeg'
import AOS from "aos";
import "aos/dist/aos.css";

export default function FeeStructure() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);
  return (
    <> 
      <section className="bg-gradient-to-r from-red-600 to-[#ff4e1c] py-24 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold" data-aos="fade-down">
            Fee Structure
          </h1> 
          <p className="mt-3 text-sky-100 text-base md:text-lg" data-aos="fade-up" data-aos-delay="150">
            Investing in Your Child's Future at <span className="scholarVarsity">Krishna Public School</span>
          </p>
        </div>
      </section>
      <div className='container my-5'>
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900" data-aos="fade-up">
            Explore Our Fee Structure
          </h2>
          <div className="w-24 h-1 bg-sky-700 mx-auto mt-4 rounded-full" data-aos="zoom-in" data-aos-delay="150"></div>
        </div>
        <div className='d-flex align-items-center justify-content-center' data-aos="zoom-in" data-aos-delay="250">
          <img src={FeeStructureImg} className="responsive" width="600" height="400" alt='GVPSFEE' />
        </div>
      </div>
    </>
  )
}
